import "./confirms";
import "./textareas";
import "./generate_doc_button";
import "./email_form";
import "./collapsed_section";
import "./collapsible_items";
import "./dynamic_list";
import "./submit_on_change";
import "./form_helpers";
import "./no_scientific_notation";
import "./integer_input";
import "./submit_once";
import "./edit_price";
import "./edit_html";
import "./datetime_input_managed";
import "./content_editor";
import "./grape_editor";
import "./zoom";
import "./training_session";

// auto-initialize components requiring JS
import "./components/accordion";
import "./components/alert";
import "./components/collapsible_fieldset";
import "./components/document_button";
import "./components/dropdown";
import "./components/highlight";
import "./components/horizontal-scroll-wrapper";
import "./components/kanbans/index";
import "./components/live-autocomplete-input";
import "./components/omnisearch";
import "./components/onboarding-alert";
import "./components/popup";
import "./components/simple_file_input";
import "./components/single_file_input";
import "./components/sticky_header";

import * as autocomplete from "./autocomplete";

document.addEventListener("DOMContentLoaded", () => {
  autocomplete.createOnLoad();
});

$(document).on("vue-render", () => autocomplete.createOnLoad());
